import React, { useEffect, useState } from 'react'
import { fetchWithFormData } from '../../apiGeneralFunction';
import { trackCustomEvent } from '../../event_firebase';
import Layout from '../Layout';
import * as Images from '../../assets';
import AllSectionone from '../ReusableComp/Sectionone';
import AboutTheProgram from './AboutTheProgram';
import DayOne from './DayOne';
import DayTwo from './DayTwo';
import DayThree from './DayThree';
import DayFour from './DayFour';
import ProgramBrochure from './ProgramBrochure';
import ThePromise from './ThePromise';

const TheEliteJewellers = () => {
    const [data, setData] = useState({ brochure: '', galleries: [] });

    useEffect(() => {
        window.scrollTo(0, 0);

        const formData = new FormData();
        fetchWithFormData('mmb_gallaries', formData)
            .then(data => {
                if (data?.status === true) {
                    setData(data?.data);
                    trackCustomEvent('mmb_gallaries', { status: true });
                } else {
                    setData([]);
                    trackCustomEvent('mmb_gallaries', { status: false });
                }
            })
            .catch(() => { setData([]); trackCustomEvent('mmb_gallaries', { status: false }); });
    }, []);

    if (!data) return null; // or a loading spinner
    return (
        <>
            <Layout>
                {/* <Sectionone/> */}
                <AllSectionone
                    src={Images.bg_services_tej}
                    title={'The Elite Jeweller\'s'}
                    link_to2={'/our_services'}
                    link_name2={'Our Services'}
                    link_to3={'/the_elite_jewellers'}
                    link_name3={'The Elite Jeweller\'s'}
                />
                <AboutTheProgram />
                <DayOne />
                <DayTwo />
                <DayThree />
                <DayFour />
                <ThePromise />
                <ProgramBrochure data={data?.brochure} />

            </Layout>
        </>
    )
}

export default TheEliteJewellers
